export const SET_USER_DATA = 'SET_CUSTOMER_DATA'
